module.exports = __webpack_public_path__ + "static/media/football-helmet.7dd4af9a.svg";